import React from 'react';
import PropTypes from 'prop-types';
import {labels} from '../../../util/uiconstants';
import styled from 'styled-components';
import FormField from '@ey/motif-react-wrapper/FormField';
import DatePicker from '@ey/motif-react-wrapper/DatePicker';
import Label from '@ey/motif-react-wrapper/Label';
import {SVGICONS} from '@ey/icons';
import moment from 'moment';

const Datepickerwrapper = styled.section`
	& .field-error {
		font-size: 12px;
		line-height: normal;
		height: var(--px-20);
		padding-top: var(--px-10);
		padding-bottom: var(--px-20);
		font-family: NotoSans, Arial Unicode MS Regular, sans-serif !important;
		& svg {
			fill: var(--red-600) !important;
			vertical-align: bottom;
			margin-right: var(--px-5);
			width: 16px;
			height: 16px;
		}
	}
	.datepicker-label {
		top: 0.2857142857rem !important;
	}
`;

class Calendar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: props.value || null,
			triggerError: false,
			isMandatory: props.isMandatory || false
		};
		this.changeDate = this.changeDate.bind(this);
	}

	componentDidUpdate(prevProp, prevState) {
		if (this.props.validationTriggerCounter)
			if (
				prevProp.validationTriggerCounter != this.props.validationTriggerCounter
			) {
				this.setState({triggerError: true});
			}
	}

	showValidation = () => {
		return (
			this.state.isMandatory &&
			this.state.triggerError &&			
			(
				!this.state.value 
				|| this.state.value === ''
				|| !(moment(this.state.value).year().toString().length === 4)
			)
		);
	};

	changeDate(date) {
		this.setState({
			value: date
		});
		this.props.onChange({name: this.props.name, value: date});
	}
	render() {
		let {
			label,
			name,
			optionalText,
			placeholder,
			title,
			value,
			disabled,
			dateFormat,
			userLocale,
			errorMessage
		} = this.props;
		return (
			<Datepickerwrapper data-autoid={name} className="text-input">
				<FormField className="form-group">
					<Label className="datepicker-label" position="in" htmlFor={name}>
						{label}
						<span data-toggle="tooltip" title={title}>
							&nbsp;
						</span>
						{optionalText && optionalText.trim() !== '' && (
							<span className="optional-tag">
								{optionalText || labels.optional}
								<span
									className=""
									data-toggle="tooltip"
									title={optionalText || labels.optional}
								>
									&nbsp;
								</span>
							</span>
						)}
					</Label>
					<StyledMotifDatePicker>
						<DatePicker
							id="date-picker"
							onChange={this.changeDate}
							value={this.state.value ? new Date(value) : ''}
							disabled={disabled}
							format={dateFormat}
							locale={userLocale}
							placeholder={placeholder}
							dayPlaceholder={'DD'}
							monthPlaceholder={'MM'}
							yearPlaceholder={'YYYY'}
						/>
					</StyledMotifDatePicker>
					{this.showValidation() && (
						<section className="field-error">
							<section>
								<SVGICONS styleName="smalll" id="icon" name="error" />
								<span>{errorMessage}</span>
							</section>
						</section>
					)}
				</FormField>
			</Datepickerwrapper>
		);
	}
}
Object.assign(Calendar, {
	propTypes: {
		label: PropTypes.string.isRequired,
		maxLength: PropTypes.number,
		name: PropTypes.string.isRequired,
		optional: PropTypes.bool,
		optionalText: PropTypes.string,
		placeholder: PropTypes.string,
		required: PropTypes.bool,
		title: PropTypes.string,
		value: PropTypes.string,
		todayDate: PropTypes.string
	},
	defaultProps: {
		disableText: false,
		maxLength: 100,
		placeholder: '',
		required: false,
		title: '',
		value: '',
		label: '',
		name: '',
		todayDate: new Date().toISOString()
	}
});
export default Calendar;

const StyledMotifDatePicker = styled.section`
	.motif-form-field {
		width: 100%;
	}
	.react-date-picker__inputGroup {
		padding-top: var(--px-19);
	}
`;
